<template>
  <Modal
    v-model="_value"
    width="500"
    title='视频文件列表'
    @on-visible-change="visibleChange"
    ok-text="关闭"
    @on-ok="onOk">

    <div style="position:relative;">
      <Table border highlight-row size="small" height="600" :columns="columns" :data="tableData"
             :height="tableHeight" ref="table"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'avfilelistmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    businessUserId: null
  },
  data () {
    return {

      id: null,

      listLoading: false,

      tableData: [],

      tableHeight: 500,

      columns: [
        {
          title: '文件名',
          key: 'fileName',
          ellipsis: 'true',
          minWidth: 250
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 90,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    window.open('https://jcerp.jianchengjt.com/api/ddm/avfileuploadrequesttask/downloadfile/' + this.id + '/' + params.row.fileName)
                  }
                }
              }, '下载')
            ])
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'ShortMessageServ_Send'
    ]),
    onOk () {

    },
    onRowClick () {

    },
    getFileList () {
      store.dispatch('AvFileUploadRequestTaskServ_GetFoldFileList', {
        params: { id: this.id },
        urlparams: null
      }).then(() => {
        this.listLoadding = false
        this.tableData = store.getters.get_AvFileUploadRequestTask_GetFoldFileListResult
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        this.id = this._initValue
        this.getFileList()
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
